import React, { Component } from "react";
import styles from "./dataAnalyse.module.scss";
import Preloader from "../../../../shared/items/static/preloader";
import { withCurrentDevices } from "../../../../shared/containers/containerCurrentDevice";
import DataAnalyseTimeRangeForm from "./DataAnalyseTimeRangeForm";
import DataAnalyseTable from "./DataAnalyseTable";
import { withDataAnalyse } from "../../../../shared/containers/containerDataAnalyse";
import { states } from "../../../../reducers/queriesStates";
import DataAnalyseChart from "./DataAnalyseChart";

class DataAnalyse extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      tabIndex: 0,
    };
  }

  componentDidUpdate(prevProps) {
    const { dataAnalyseDataState } = this.props;
    const { isLoading } = this.state;

    if (dataAnalyseDataState === states.REQUEST && prevProps.dataAnalyseDataState !== states.REQUEST) {
      this.setState({ isLoading: true });
    }

    if (isLoading && dataAnalyseDataState === states.READY) {
      this.setState({ isLoading: false });
    }
  }

  getTabView() {
    const { tabIndex } = this.state;

    switch (tabIndex) {
      case 1:
        return <DataAnalyseTable />;
      case 0:
        return <DataAnalyseChart />;

      default:
        return null;
    }
  }

  setTabIndex(index) {
    this.setState({ tabIndex: index });
  }

  getTabs() {
    const { tabIndex } = this.state;
    const titles = ["График", "Таблица"];

    return titles.map((item, index) => {
      return (
        <div key={index} className={tabIndex === index ? styles.cmsTabActive : styles.cmsTab} onClick={this.setTabIndex.bind(this, index)}>
          {item}
        </div>
      );
    });
  }

  render() {
    const { isLoading } = this.state;

    if (isLoading) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    const { deviceId, currentDevice } = this.props;

    return (
      <div className={styles.dataAnalyseCompainer}>
        <DataAnalyseTimeRangeForm />
        <div className={styles.cmsTabsContainer}>{this.getTabs()}</div>
        {currentDevice.id === deviceId ? this.getTabView() : null}
      </div>
    );
  }
}

export default withDataAnalyse(withCurrentDevices(DataAnalyse));
